module.exports = __webpack_public_path__ + "static/media/sports.d154c9ef.jpg";